import type { SVGProps } from 'react';
const SvgArrowUp = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <path d="m19.956 7.544-7.25-7.25a1.001 1.001 0 0 0-1.416 0l-7.25 7.25L5.456 8.96 11 3.416V24h2V3.416l5.544 5.544 1.413-1.416z" />
  </svg>
);
export default SvgArrowUp;
